export const en = {
  msg:
    {
      username: 'Username',
      password: 'Password',
      login: 'Login',
      changeLanguage: '',
      'lang-en': 'English',
      'lang-ms': 'Bahasa Melayu',
      submit_button_text: 'Submit',
      enter: 'Enter',
      en: 'English',
      ms: 'Bahasa Melayu',
      id: 'Bahasa Indonesia',
      zh: 'Chinese',
      to: 'Tongan',
      copyright: 'Powered by Global Psytech',
      new_password: 'New Password',
      confirm_new_password: 'Confirm New Password',
      forgot_password_header: 'Forgot Password',
      basic_info: 'Basic Information',
      password_set: 'Set Password',
      sign_up: 'Sign Up',
      product_info: 'Product Applied',
      continue: 'Continue',
      back: 'Back',
      cancel_reset: 'Cancel',
      forgot_password: 'Forgot Password?',
      sign_up_message: 'to create an account',
      reset_success: 'Successfully reset your password. Please login using the new password.',
      dpa_heading: 'Personal Data Protection Agreement',
      dpa_body1: 'GFI hereby undertakes to maintain the confidentiality of the information provided herein consistent with the Data Protection Act. In compliance with regulations concerning data protection, we will ensure that the data/information collected in this assessment will only be submitted to the client, or to the client’s authorised representatives.',
      dpa_body2: 'All data/information will be stored and transmitted suitably and securely, whether the client is located within or outside Tonga.',
      dpa_body3: 'Any further communication regarding the use of data/information will be subject to terms and conditions of the client and its subject.',
      close: 'Close',
      reset_button: 'Submit',
      successfully_register: 'You have successfully registered. Please log in using your registered username and password.',
      cloned_user: 'Your last GFI score is still valid. Hence, you do not need to retake the GFI assessment.',
      password_changed: 'Please login with your new password.',
      loading_text: 'loading...',
      month_label: 'Months',
      create_registration: 'Create your Username and Password',
      login_instruction:'Instructions',
      login_instruction_title:'Before taking the assessment, please ensure the following:',
      login_instruction_1_heading:'Guide for Taking GFI Assessment',
      login_instruction_1:' – Read all instructions carefully before starting.',
      login_instruction_2_heading:'Quiet Environment',
      login_instruction_2:' – Choose a quiet place where you will not be disturbed.',
      login_instruction_3_heading:'Time Allocation',
      login_instruction_3:' – Set aside enough uninterrupted time to complete the assessment in one sitting.',
      user_guide: 'User Guide'
    },
  error: {
    full_name_required: 'Please enter your full name as indicated on your official ID.',
    full_name_min: 'The name must be at least 5 characters long.',
    full_name_max: 'The name cannot be longer than 80 characters.',
    full_name_regex: 'The only acceptable characters are letters of the alphabet, spaces, and the following special characters: @ ’ - and /',

    // id_num_required: 'Please enter your ID number.',
    // id_num_max: 'The ID must not be longer than 20 characters.',
    // id_num_regex: 'The only acceptable characters are letters of the alphabet and numerals.',

    business_reg_required: 'Please enter your company’s business registration / business license number.',
    business_reg_max: 'The business license number must not be longer than 20 characters.',
    business_reg_min: 'The business license number must be at least 5 characters long.',
    business_reg_regex: 'The only acceptable characters are letters of the alphabet and numerals.',

    id_num_required: 'Please enter your ID number.',
    id_num_min: 'The ID number must be at least {0} characters long.',
    id_num_max: 'The ID number must not be longer than {0} characters.',
    id_num_regex: 'The ID number contains invalid characters.',

    email_address_required: 'Please enter your email address.',
    email_address_max: 'The email address cannot be longer than 200 characters long.',
    email_address_email: 'Please enter a valid email address.',

    phone_number_required: 'Please enter your phone number',
    phone_number_min: 'The phone number must be at least 5 characters long.',
    phone_number_max: 'The phone number cannot be longer than 15 characters long.',
    phone_number_regex: 'The only acceptable characters are numerals and the following special characters: ( ) and -',

    physical_address_required: 'Please enter your physical address',
    physical_address_min: 'The physical address must be at least 5 characters long.',
    physical_address_max: 'The physical address cannot be longer than 200 characters long.',
    physical_address_regex: 'The only acceptable characters are letters of the alphabet, spaces, and the following special characters: @ ’ - , () and /',

    company_name_required: 'Please enter your company’s name.',
    company_name_min: 'The company name must be at least 5 characters long.',
    company_name_max: 'The company name must not be longer than 80 characters.',
    company_name_regex: 'The only acceptable characters are letters of the alphabet, spaces, numerals, and the following special characters: . - & () and ’',

    business_category_required: 'Select business category.',
    product_applied_required: 'Please select the product you are applying.',
    commencement_date_required: 'Please enter your company’s business commencement date.',
    facility_required: 'Please select the facilities you are applying.',
    facilities_required: 'Please select the facilities you are applying.',

    amount_applied_required: 'Please enter the requested financing amount.',
    amount_applied_maxvalue: 'The financing amount must not exceed {1}.',
    amount_applied_minvalue: 'The financing amount requested must be at least {0} .',

    tenure_required: 'Please enter the financing tenure you are applying.',
    tenure_maxvalue: 'The maximum financing tenure must not exceed {1} months.',
    tenure_minvalue: 'The minimum financing tenure must be at least {0} month.',

    officerinchargeid_required: 'Please enter the ID number of Loan Officer you are dealing with.',
    officerinchargeid_invalid: 'Invalid Loan Officer ID. Please enter the correct Loan Officer ID.',
    officerinchargeid_regex: 'The only acceptable characters are letters of the alphabet, numeral and the following special characters: ! # - and @',
    officerinchargeid_min: 'The ID must be at least 6 characters long.',
    officerinchargeid_max: 'The ID number cannot be longer than 15 characters.',

    username_required: 'Please enter a username.',
    username_min: 'Your username must be at least 6 characters long.',
    username_max: 'Your username cannot be longer than 15 characters.',
    username_regex: 'The only acceptable characters are letters of the alphabet, numeral and the following special characters: ! # - and @',
    username_duplicate: 'Username has already been taken. Please enter a different username.',

    password_required: 'Please enter a password.',
    password_min: 'Your password must be at least 6 characters long.',
    password_max: 'Your password cannot be longer than 15 characters.',
    password_regex: 'The only acceptable characters are letters of the alphabet, numerals, and the following special characters: ! # - and @',
    confirm_password_regex: 'The only acceptable characters are letters of the alphabet, numerals, and the following special characters: ! # - and @',
    new_password_regex: 'The only acceptable characters are letters of the alphabet, numerals, and the following special characters: ! # - and @',

    confirm_password_required: 'Please re-enter your password for confirmation.',
    confirm_password_confirmed: 'Your password and confirmation password do not match.',
    confirm_password_min: 'Your password must be at least 6 characters long.',
    confirm_password_max: 'Your password cannot be longer than 15 characters.',

    registrationtoken_required: 'Please enter the verification code that has been given to you.',
    registrationtoken_min: 'Your verification code needs to be 6 characters long.',
    registrationtoken_max: 'Your verification code needs to be 6 characters long.',
    registrationtoken_duplicate: 'Invalid verification code. Please enter the correct verification code.',
    registrationtoken_regex: 'The only acceptable characters are letters of the alphabet and numerals.',
    registrationtoken_invalid: 'Invalid verification code. Please enter the correct verification code.',

    confirm_password_placeholder: 'Please re-enter your password',

    error: 'Invalid username or password',
    registration_error: 'Something went wrong please try again',
    new_password_required: 'Please enter your new password',
    confirm_new_password_required: 'Please re-enter your password for confirmation',
    invalid_credentials: 'Invalid username or password.',

    consent_required: 'Before you can be registered, you must read the Personal Data Protection Agreement and accept it by checking the box provided',

    reset_invalid: 'We are unable to find your account by the details provided.',
    new_password_min: 'Your password must be at least 6 characters long.',
    new_password_max: 'Your password cannot be longer than 15 characters.',
    confirm_new_password_min: 'Your password must be at least 6 characters long.',
    confirm_new_password_max: 'Your password cannot be longer than 15 characters.',
    confirm_new_password_confirmed: 'Your password and confirmed passwords do not match.',
    register_username_details_does_not_match: 'Your identification number does not match the registration record.',
    registrationtoken_username_details_does_not_match:'Your verification code does not match the registration record.',
    register_username_not_found: 'Forgot your username? Please contact support.',
    data_tempered: 'Unable to reset your password. Please try again later.',
    branch_required: 'Please select the Branch.',
    drop_down_not_available: 'No data available',
    repeating_user: 'Sorry, your registration cannot be processed.',

    id_type_required: 'Please select your ID document type.'
  },
  registration: {
    full_name: 'Full Name (as per your ID)',
    id_num: 'Identification Number (ID)',
    email_address: 'Email Address',
    phone_number: 'Phone Number',
    physical_address: 'Physical Address',
    business_reg: 'Business Registration/ Business License No.',
    company_name: 'Company Name',
    product_applied: 'Product Applied',
    commencement_date: 'Business Commencement Date',
    facilities: 'Facilities Applied',
    amount_applied: 'Financing Amount Requested (Pa’anga)',
    tenure: 'Financing Tenure (in months)',
    business_category: 'Business Category',
    confirm_password: 'Confirm Password',
    verification_code: 'Verification Code',
    consent1: 'I have read and understood',
    consent2: 'Personal Data Protection Agreement',
    consent3: 'and agree to the use of my personal data as specified in that Agreement.',
    cancel: 'Cancel',
    register: 'Register',
    branch: 'Branch',
    officer: 'Loan Officer ID No.',
    id_type: 'ID Document Type'
  }
}
